  import React from 'react';
  import { Navigate } from 'react-router-dom';
  import { useAuth } from '../AuthContext';
  import Loading from '../components/Loading';

  function ProtectedRoute({ element }) {
    const { isAuthenticated, isLoading } = useAuth();

    // 인증 상태를 확인하는 동안 로딩 화면 표시
    if (isLoading || isAuthenticated === null) {
      return <div><Loading /></div>;
    }

    // 인증되지 않은 경우 로그인 페이지로 리다이렉트
    if (!isAuthenticated) {
      return <Navigate to="/login" />;
    }

    // 인증된 경우 실제 컴포넌트 렌더링
    return element;
  }

  export default ProtectedRoute;
